import {
  Drawer as MUIDrawer,
  ListItem as MUIListItem,
  ListItemButton as MUIListItemButton,
  ListItemIcon as MUIListItemIcon,
  ListItemText as MUIListItemText,
  styled,
} from '@mui/material';

export const Drawer = styled(MUIDrawer)(({ theme }) => ({
  '.MuiDrawer-paper': {
    backgroundColor: theme.palette.primary.main,
  },
}));

export const ListItem = styled(MUIListItem)(({ theme }) => ({
  justifyContent: 'center',
  marginBottom: theme.spacing(1),
  marginTop: theme.spacing(1),
  padding: 0,
}));

export const ListItemButton = styled(MUIListItemButton)(({ theme }) => ({
  borderRadius: '4px',
  flexDirection: 'column',
  marginLeft: theme.spacing(1),
  marginRight: theme.spacing(1),
  '&:hover, &.Mui-selected': {
    '.MuiListItemIcon-root': {
      color: theme.palette.primary.contrastText,
    },
    '.MuiListItemText-root': {
      span: {
        color: theme.palette.primary.contrastText,
      },
    },
  },
  '&:hover, &.Mui-selected:hover': {
    backgroundColor: theme.palette.primary.hover,
  },
  '&.Mui-selected': {
    background: theme.palette.primary.dark,
    '.MuiListItemIcon-root::before': {
      backgroundColor: theme.palette.primary.contrastText,
      content: '""',
      display: 'inline-block',
      height: 15,
      left: 0,
      position: 'absolute',
      top: 25,
      width: 3,
    },
  },
}));

export const ListItemIcon = styled(MUIListItemIcon)(({ theme }) => ({
  color: theme.palette.primary.mutedText,
  justifyContent: 'center',
}));

export const ListItemText = styled(MUIListItemText)(({ theme }) => ({
  span: {
    color: theme.palette.primary.mutedText,
  },
}));
